var _rect, _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTextToVoice1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 108,
    height: 108,
    viewBox: "0 0 108 108",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 108,
    height: 108,
    rx: 54,
    fill: "#DE5824"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M66.4895 71.8198H42.6611",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M66.4895 62.2312H42.6611",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.1254 24C67.1254 24 41.7888 24.0132 41.7492 24.0132C32.6403 24.0693 27 30.0627 27 39.2046V69.5545C27 78.7426 32.6832 84.7591 41.8713 84.7591C41.8713 84.7591 67.2046 84.7492 67.2475 84.7492C76.3564 84.6931 82 78.6964 82 69.5545V39.2046C82 30.0165 76.3135 24 67.1254 24Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M62.3873 35.3395C63.9731 36.1459 65.3285 37.3414 66.3267 38.814C67.3249 40.2866 67.9333 41.9884 68.095 43.7601V45.6682C67.9395 47.3928 67.3606 49.0524 66.4098 50.4996C65.459 51.9468 64.1656 53.1369 62.6444 53.9643L61.6406 52.0313C62.9713 51.3003 64.0771 50.2198 64.8388 48.9064C65.6004 47.593 65.9889 46.0965 65.9625 44.5785C65.936 43.0605 65.4955 41.5785 64.6886 40.2924C63.8816 39.0063 62.7388 37.965 61.3834 37.2808L62.3873 35.3395ZM55.1945 33.7965L50.4989 38.7741L44.6169 38.6746H44.4759C43.9227 38.7063 43.4025 38.9481 43.0216 39.3506C42.6408 39.753 42.428 40.2858 42.4268 40.8399V48.099C42.4268 48.6755 42.6558 49.2283 43.0634 49.6359C43.471 50.0436 44.0239 50.2726 44.6003 50.2726H50.4076L55.1779 54.628C55.4061 54.8648 55.6995 55.0285 56.0208 55.0982C56.3421 55.168 56.677 55.1407 56.9827 55.0198C57.2885 54.8989 57.5515 54.6898 57.7383 54.4192C57.9251 54.1486 58.0272 53.8286 58.0318 53.4998V34.9247C58.024 34.5994 57.9207 34.2835 57.7348 34.0165C57.5489 33.7494 57.2885 33.5429 56.9861 33.4226C56.6838 33.3024 56.3527 33.2737 56.0341 33.3402C55.7156 33.4066 55.4236 33.5653 55.1945 33.7965V33.7965ZM55.8748 52.2802L51.2704 48.0741H44.6335V40.815L51.453 40.9311L55.908 36.2438L55.8748 52.2802Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M60.5536 38.8738C61.5265 39.4464 62.334 40.2617 62.8973 41.24C63.4605 42.2183 63.7601 43.326 63.7668 44.4548C63.7735 45.5836 63.487 46.6949 62.9354 47.6798C62.3838 48.6647 61.586 49.4895 60.62 50.0736L59.6162 48.1323C60.2276 47.7336 60.7287 47.1875 61.0735 46.5442C61.4183 45.9009 61.5955 45.1812 61.5889 44.4513C61.5823 43.7215 61.392 43.0051 61.0357 42.3682C60.6793 41.7312 60.1683 41.1943 59.5498 40.8068L60.5536 38.8738Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTextToVoice1);
export default __webpack_public_path__ + "static/media/Text_to_voice_1.1b7b40903f336c01f2284a0c0da60c18.svg";
export { ForwardRef as ReactComponent };